import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem('dealroom_cookie_consent');
    if (!hasConsented) {
      // Show banner after a short delay
      setTimeout(() => setShowBanner(true), 1500);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('dealroom_cookie_consent', 'true');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up">
      <div className="bg-slate-900/95 backdrop-blur-xl border-t border-white/10 shadow-2xl">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-start gap-3 flex-1">
              <div className="flex-shrink-0 text-2xl">
                🍪
              </div>
              <div className="text-sm text-slate-300">
                <p>
                  We use only <strong className="text-white">essential cookies</strong> to provide secure access to the Jigsaw Deal Room. 
                  By continuing, you agree to our{" "}
                  <Link to="/legal/privacy" className="text-cyan-400 hover:text-cyan-300 underline">
                    Privacy Notice
                  </Link>
                  {" "}and{" "}
                  <Link to="/legal/cookies" className="text-cyan-400 hover:text-cyan-300 underline">
                    Cookie Policy
                  </Link>.
                </p>
              </div>
            </div>
            <button
              onClick={handleAccept}
              className="flex-shrink-0 bg-cyan-500 hover:bg-cyan-600 text-white font-semibold px-6 py-2.5 rounded-xl transition-colors"
              data-testid="cookie-consent-accept"
            >
              OK, I Understand
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
